<template>
    <div class="mosaic" style="background: #EFEFEF">
        <v-container fluid v-if="flag">
            <v-row justify="center">
                <v-col cols="12" sm="12" md="10" lg="6" style="background-color: white" class="pa-0">
                    <v-card class="px-3 pt-12">
                        <v-row no-gutters style="max-height: 80px;" class="c-px pt-4">
                            <v-col cols="6" class="px-0">
                                <span class="gtAmerica-extended uppercase d-block mosaic-title" v-html="mosaic.title"></span>
                                <span class="uppercase d-block mt-4 mosaic-subtitle" style="white-space: break-spaces;">{{this.mosaic.subtitle}}</span>
                            </v-col>
                            <v-col cols="6" class="text-right px-0">
                                <router-link to="/">
                                    <v-img
                                        alt="Artless Logo"
                                        class="shrink logo-artless-header-mosaic ml-auto"
                                        contain
                                        src="@/assets/img/icons/artless-logo-negro.svg"
                                        transition="scale-transition"
                                        max-width="100%"
                                    />
                                </router-link>
                            </v-col>
                        </v-row>
                        <v-row align="end" class="c-px">
                            <v-col cols="6" class="c-py c-px">
                                <template v-if="isUrl(this.mosaic.firstImage.meta.title)">
                                    <a :href="this.mosaic.firstImage.meta.title">
                                        <v-img :src="'https://www.artlesscms.actstudio.xyz/'+this.mosaic.firstImage.path" aspect-ratio="1.08" :contain="false" width="100%"></v-img>
                                    </a>
                                </template>
                                <template v-else-if="isLocalUrl(this.mosaic.firstImage.meta.title)">
                                    <router-link :to="this.mosaic.firstImage.meta.title">
                                        <v-img :src="'https://www.artlesscms.actstudio.xyz/'+this.mosaic.firstImage.path" aspect-ratio="1.08" :contain="false" width="100%"></v-img>
                                    </router-link>
                                </template>
                                <template v-else>
                                    <v-img :src="'https://www.artlesscms.actstudio.xyz/'+this.mosaic.firstImage.path" aspect-ratio="1.08" :contain="false" width="100%"></v-img>
                                </template>
                            </v-col>
                            <v-col cols="6" class="c-py c-px">
                                <template v-if="isUrl(this.mosaic.secondImage.meta.title)">
                                    <a :href="this.mosaic.secondImage.meta.title">
                                        <v-img :src="'https://www.artlesscms.actstudio.xyz/'+this.mosaic.secondImage.path" aspect-ratio=".8" position="center bottom"></v-img>
                                    </a>
                                </template>
                                <template v-else-if="isLocalUrl(this.mosaic.secondImage.meta.title)">
                                    <router-link :to="this.mosaic.secondImage.meta.title">
                                        <v-img :src="'https://www.artlesscms.actstudio.xyz/'+this.mosaic.secondImage.path" aspect-ratio=".8" position="center bottom"></v-img>
                                    </router-link>
                                </template>
                                <template v-else>
                                    <v-img :src="'https://www.artlesscms.actstudio.xyz/'+this.mosaic.secondImage.path" aspect-ratio=".8" position="center bottom"></v-img>
                                </template>
                            </v-col>
                        </v-row>


                        <template v-for="(gallery,g) in mosaic.content">

                            <template v-if="gallery.field.name == 'GalleryA'">
                                <v-row :key="'GalleryA-'+g" align="start" class="c-px">
                                    <v-col cols="4" class="py-0">
                                        <template v-for="(item,i) in gallery.value">
                                            <template v-if="i == 0">
                                                <v-row :key="'item-'+g+'-'+i" >
                                                    <v-col class="c-py c-px">
                                                        <template v-if="isUrl(item.meta.title)">
                                                            <a :href="item.meta.title">
                                                                <v-img :src="'https://www.artlesscms.actstudio.xyz/'+item.path" aspect-ratio="1.1" width="100%"></v-img>
                                                            </a>
                                                        </template>
                                                        <template v-else-if="isLocalUrl(item.meta.title)">
                                                            <router-link :to="item.meta.title">
                                                                <v-img :src="'https://www.artlesscms.actstudio.xyz/'+item.path" aspect-ratio="1.1" width="100%"></v-img>
                                                            </router-link>
                                                        </template>
                                                        <template v-else>
                                                            <v-img :src="'https://www.artlesscms.actstudio.xyz/'+item.path" aspect-ratio="1.1" width="100%"></v-img>
                                                        </template>
                                                    </v-col>
                                                </v-row>
                                            </template>
                                            <template v-if="i == 3">
                                                <v-row :key="'item-'+g+'-'+i" >
                                                    <v-col class="c-py c-px">
                                                        <template v-if="isUrl(item.meta.title)">
                                                            <a :href="item.meta.title">
                                                                <v-img :src="'https://www.artlesscms.actstudio.xyz/'+item.path" aspect-ratio="1.1" width="100%"></v-img>
                                                            </a>
                                                        </template>
                                                        <template v-else-if="isLocalUrl(item.meta.title)">
                                                            <router-link :to="item.meta.title">
                                                                <v-img :src="'https://www.artlesscms.actstudio.xyz/'+item.path" aspect-ratio="1.1" width="100%"></v-img>
                                                            </router-link>
                                                        </template>
                                                        <template v-else>
                                                            <v-img :src="'https://www.artlesscms.actstudio.xyz/'+item.path" aspect-ratio="1.1" width="100%"></v-img>
                                                        </template>
                                                    </v-col>
                                                </v-row>
                                            </template>
                                            <template v-if="i == 5">
                                                <v-row :key="'item-'+g+'-'+i" >
                                                    <v-col class="c-py c-px">
                                                        <template v-if="isUrl(item.meta.title)">
                                                            <a :href="item.meta.title">
                                                                <v-img :src="'https://www.artlesscms.actstudio.xyz/'+item.path" :height="galleryARectangle" width="100%"></v-img>
                                                            </a>
                                                        </template>
                                                        <template v-else-if="isLocalUrl(item.meta.title)">
                                                            <router-link :to="item.meta.title">
                                                                <v-img :src="'https://www.artlesscms.actstudio.xyz/'+item.path" :height="galleryARectangle" width="100%"></v-img>
                                                            </router-link>
                                                        </template>
                                                        <template v-else>
                                                            <v-img :src="'https://www.artlesscms.actstudio.xyz/'+item.path" :height="galleryARectangle" width="100%"></v-img>
                                                        </template>
                                                    </v-col>
                                                </v-row>
                                            </template>
                                        </template>
                                    </v-col>
                                    <v-col cols="8" class="py-0">
                                        <v-row>
                                            <v-col cols="6" class="c-py c-px">
                                                <template v-for="(item,i) in gallery.value">
                                                    <template v-if="i == 1">
                                                        <template v-if="isUrl(item.meta.title)">
                                                            <a :href="item.meta.title" :key="'item-'+g+'-'+i">
                                                                <v-img :src="'https://www.artlesscms.actstudio.xyz/'+item.path" aspect-ratio="1.1" width="100%" :key="'item-'+g+'-'+i"></v-img>
                                                            </a>
                                                        </template>
                                                        <template v-else-if="isLocalUrl(item.meta.title)">
                                                            <router-link :to="item.meta.title" :key="'item-'+g+'-'+i">
                                                                <v-img :src="'https://www.artlesscms.actstudio.xyz/'+item.path" aspect-ratio="1.1" width="100%" :key="'item-'+g+'-'+i"></v-img>
                                                            </router-link>
                                                        </template>
                                                        <template v-else>
                                                            <v-img :src="'https://www.artlesscms.actstudio.xyz/'+item.path" aspect-ratio="1.1" width="100%" :key="'item-'+g+'-'+i"></v-img>
                                                        </template>
                                                    </template>
                                                </template>
                                            </v-col>
                                            <v-col cols="6" class="c-py c-px">
                                                <template v-for="(item,i) in gallery.value">
                                                    <template v-if="i == 2">
                                                        <template v-if="isUrl(item.meta.title)">
                                                            <a :href="item.meta.title" :key="'item-'+g+'-'+i">
                                                                <v-img :src="'https://www.artlesscms.actstudio.xyz/'+item.path" aspect-ratio="1.1" width="100%" :key="'item-'+g+'-'+i"></v-img>
                                                            </a>
                                                        </template>
                                                        <template v-else-if="isLocalUrl(item.meta.title)">
                                                            <router-link :to="item.meta.title" :key="'item-'+g+'-'+i">
                                                                <v-img :src="'https://www.artlesscms.actstudio.xyz/'+item.path" aspect-ratio="1.1" width="100%" :key="'item-'+g+'-'+i"></v-img>
                                                            </router-link>
                                                        </template>
                                                        <template v-else>
                                                            <v-img :src="'https://www.artlesscms.actstudio.xyz/'+item.path" aspect-ratio="1.1" width="100%" :key="'item-'+g+'-'+i"></v-img>
                                                        </template>
                                                    </template>
                                                </template>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col class="c-px c-py">
                                                <template v-for="(item,i) in gallery.value">
                                                    <template v-if="i == 4">
                                                        <template v-if="isUrl(item.meta.title)">
                                                            <a :href="item.meta.title" :key="'item-'+g+'-'+i">
                                                                <v-img :src="'https://www.artlesscms.actstudio.xyz/'+item.path" :height="galleryARectangle" width="100%" :key="'item-'+g+'-'+i"></v-img>
                                                            </a>
                                                        </template>
                                                        <template v-else-if="isLocalUrl(item.meta.title)">
                                                            <router-link :to="item.meta.title" :key="'item-'+g+'-'+i">
                                                                <v-img :src="'https://www.artlesscms.actstudio.xyz/'+item.path" :height="galleryARectangle" width="100%" :key="'item-'+g+'-'+i"></v-img>
                                                            </router-link>
                                                        </template>
                                                        <template v-else>
                                                            <v-img :src="'https://www.artlesscms.actstudio.xyz/'+item.path" :height="galleryARectangle" width="100%" :key="'item-'+g+'-'+i"></v-img>
                                                        </template>
                                                    </template>
                                                </template>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="6" class="pb-0 c-pt c-px">
                                                <template v-for="(item,i) in gallery.value">
                                                    <template v-if="i == 6">
                                                        <template v-if="isUrl(item.meta.title)">
                                                            <a :href="item.meta.title" :key="'item-'+g+'-'+i">
                                                                <v-img :src="'https://www.artlesscms.actstudio.xyz/'+item.path" aspect-ratio="1.1" width="100%" :key="'item-'+g+'-'+i"></v-img>
                                                            </a>
                                                        </template>
                                                        <template v-else-if="isLocalUrl(item.meta.title)">
                                                            <router-link :to="item.meta.title" :key="'item-'+g+'-'+i">
                                                                <v-img :src="'https://www.artlesscms.actstudio.xyz/'+item.path" aspect-ratio="1.1" width="100%" :key="'item-'+g+'-'+i"></v-img>
                                                            </router-link>
                                                        </template>
                                                        <template v-else>
                                                            <v-img :src="'https://www.artlesscms.actstudio.xyz/'+item.path" aspect-ratio="1.1" width="100%" :key="'item-'+g+'-'+i"></v-img>
                                                        </template>
                                                    </template>
                                                </template>
                                            </v-col>
                                            <v-col cols="6" class="pb-0 c-pt c-px">
                                                <template v-for="(item,i) in gallery.value">
                                                    <template v-if="i == 7">
                                                        <template v-if="isUrl(item.meta.title)">
                                                            <a :href="item.meta.title" :key="'item-'+g+'-'+i">
                                                                <v-img :src="'https://www.artlesscms.actstudio.xyz/'+item.path" aspect-ratio="1.1" width="100%" :key="'item-'+g+'-'+i"></v-img>
                                                            </a>
                                                        </template>
                                                        <template v-else-if="isLocalUrl(item.meta.title)">
                                                            <router-link :to="item.meta.title" :key="'item-'+g+'-'+i">
                                                                <v-img :src="'https://www.artlesscms.actstudio.xyz/'+item.path" aspect-ratio="1.1" width="100%" :key="'item-'+g+'-'+i"></v-img>
                                                            </router-link>
                                                        </template>
                                                        <template v-else>
                                                            <v-img :src="'https://www.artlesscms.actstudio.xyz/'+item.path" aspect-ratio="1.1" width="100%" :key="'item-'+g+'-'+i"></v-img>
                                                        </template>
                                                    </template>
                                                </template>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </template>

                            <template v-if="gallery.field.name == 'GalleryB'">
                                <div :key="'GalleryB-'+g">
                                    <v-row align="start" class="px-2">
                                        <v-col cols="8" class="c-py c-px">
                                            <template v-for="(item,i) in gallery.value">
                                                <template v-if="i == 0">
                                                    <template v-if="isUrl(item.meta.title)">
                                                        <a :href="item.meta.title" :key="'item-'+g+'-'+i">
                                                            <v-img :src="'https://www.artlesscms.actstudio.xyz/'+item.path" width="100%" :height="galleryBRectangle" :key="'item-'+g+'-'+i" position="center bottom"></v-img>
                                                        </a>
                                                    </template>
                                                    <template v-else-if="isLocalUrl(item.meta.title)">
                                                        <router-link :to="item.meta.title" :key="'item-'+g+'-'+i">
                                                            <v-img :src="'https://www.artlesscms.actstudio.xyz/'+item.path" width="100%" :height="galleryBRectangle" :key="'item-'+g+'-'+i" position="center bottom"></v-img>
                                                        </router-link>
                                                    </template>
                                                    <template v-else>
                                                        <v-img :src="'https://www.artlesscms.actstudio.xyz/'+item.path" width="100%" :height="galleryBRectangle" :key="'item-'+g+'-'+i" position="center bottom"></v-img>
                                                    </template>
                                                </template>
                                            </template>
                                        </v-col>
                                        <v-col cols="4" class="c-py c-px">
                                            <template v-for="(item,i) in gallery.value">
                                                <template v-if="i == 1">
                                                    <template v-if="isUrl(item.meta.title)">
                                                        <a :href="item.meta.title" :key="'item-'+g+'-'+i">
                                                            <v-img :src="'https://www.artlesscms.actstudio.xyz/'+item.path" width="100%" :height="galleryBRectangle" :key="'item-'+g+'-'+i"></v-img>
                                                        </a>
                                                    </template>
                                                    <template v-else-if="isLocalUrl(item.meta.title)">
                                                        <router-link :to="item.meta.title" :key="'item-'+g+'-'+i">
                                                            <v-img :src="'https://www.artlesscms.actstudio.xyz/'+item.path" width="100%" :height="galleryBRectangle" :key="'item-'+g+'-'+i"></v-img>
                                                        </router-link>
                                                    </template>
                                                    <template v-else>
                                                        <v-img :src="'https://www.artlesscms.actstudio.xyz/'+item.path" width="100%" :height="galleryBRectangle" :key="'item-'+g+'-'+i"></v-img>
                                                    </template>
                                                </template>
                                            </template>
                                        </v-col>
                                        <v-col cols="4" class="c-py c-px">
                                            <template v-for="(item,i) in gallery.value">
                                                <template v-if="i == 2">
                                                    <template v-if="isUrl(item.meta.title)">
                                                        <a :href="item.meta.title" :key="'item-'+g+'-'+i">
                                                            <v-img :src="'https://www.artlesscms.actstudio.xyz/'+item.path" aspect-ratio="1.1" width="100%" :key="'item-'+g+'-'+i"></v-img>
                                                        </a>
                                                    </template>
                                                    <template v-else-if="isLocalUrl(item.meta.title)">
                                                        <router-link :to="item.meta.title" :key="'item-'+g+'-'+i">
                                                            <v-img :src="'https://www.artlesscms.actstudio.xyz/'+item.path" aspect-ratio="1.1" width="100%" :key="'item-'+g+'-'+i"></v-img>
                                                        </router-link>
                                                    </template>
                                                    <template v-else>
                                                        <v-img :src="'https://www.artlesscms.actstudio.xyz/'+item.path" aspect-ratio="1.1" width="100%" :key="'item-'+g+'-'+i"></v-img>
                                                    </template>
                                                </template>
                                            </template>
                                        </v-col>
                                        <v-col cols="4" class="c-py c-px">
                                            <template v-for="(item,i) in gallery.value">
                                                <template v-if="i == 3">
                                                    <template v-if="isUrl(item.meta.title)">
                                                        <a :href="item.meta.title" :key="'item-'+g+'-'+i">
                                                            <v-img :src="'https://www.artlesscms.actstudio.xyz/'+item.path" aspect-ratio="1.1" width="100%" :key="'item-'+g+'-'+i"></v-img>
                                                        </a>
                                                    </template>
                                                    <template v-else-if="isLocalUrl(item.meta.title)">
                                                        <router-link :to="item.meta.title" :key="'item-'+g+'-'+i">
                                                            <v-img :src="'https://www.artlesscms.actstudio.xyz/'+item.path" aspect-ratio="1.1" width="100%" :key="'item-'+g+'-'+i"></v-img>
                                                        </router-link>
                                                    </template>
                                                    <template v-else>
                                                        <v-img :src="'https://www.artlesscms.actstudio.xyz/'+item.path" aspect-ratio="1.1" width="100%" :key="'item-'+g+'-'+i"></v-img>
                                                    </template>
                                                </template>
                                            </template>
                                        </v-col>
                                        <v-col cols="4" class="c-py c-px">
                                            <template v-for="(item,i) in gallery.value">
                                                <template v-if="i == 4">
                                                    <template v-if="isUrl(item.meta.title)">
                                                        <a :href="item.meta.title" :key="'item-'+g+'-'+i">
                                                            <v-img :src="'https://www.artlesscms.actstudio.xyz/'+item.path" aspect-ratio="1.1" width="100%" :key="'item-'+g+'-'+i"></v-img>
                                                        </a>
                                                    </template>
                                                    <template v-else-if="isLocalUrl(item.meta.title)">
                                                        <router-link :to="item.meta.title" :key="'item-'+g+'-'+i">
                                                            <v-img :src="'https://www.artlesscms.actstudio.xyz/'+item.path" aspect-ratio="1.1" width="100%" :key="'item-'+g+'-'+i"></v-img>
                                                        </router-link>
                                                    </template>
                                                    <template v-else>
                                                        <v-img :src="'https://www.artlesscms.actstudio.xyz/'+item.path" aspect-ratio="1.1" width="100%" :key="'item-'+g+'-'+i"></v-img>
                                                    </template>
                                                </template>
                                            </template>
                                        </v-col>
                                        <v-col cols="6" class="c-py c-px">
                                            <template v-for="(item,i) in gallery.value">
                                                <template v-if="i == 5">
                                                    <template v-if="isUrl(item.meta.title)">
                                                        <a :href="item.meta.title" :key="'item-'+g+'-'+i">
                                                            <v-img :src="'https://www.artlesscms.actstudio.xyz/'+item.path" aspect-ratio="1.5" width="100%" :key="'item-'+g+'-'+i"></v-img>
                                                        </a>
                                                    </template>
                                                    <template v-else-if="isLocalUrl(item.meta.title)">
                                                        <router-link :to="item.meta.title" :key="'item-'+g+'-'+i">
                                                            <v-img :src="'https://www.artlesscms.actstudio.xyz/'+item.path" aspect-ratio="1.5" width="100%" :key="'item-'+g+'-'+i"></v-img>
                                                        </router-link>
                                                    </template>
                                                    <template v-else>
                                                        <v-img :src="'https://www.artlesscms.actstudio.xyz/'+item.path" aspect-ratio="1.5" width="100%" :key="'item-'+g+'-'+i"></v-img>
                                                    </template>
                                                </template>
                                            </template>
                                        </v-col>
                                        <v-col cols="6" class="c-py c-px">
                                            <template v-for="(item,i) in gallery.value">
                                                <template v-if="i == 6">
                                                    <template v-if="isUrl(item.meta.title)">
                                                        <a :href="item.meta.title" :key="'item-'+g+'-'+i">
                                                            <v-img :src="'https://www.artlesscms.actstudio.xyz/'+item.path" aspect-ratio="1.5" width="100%" :key="'item-'+g+'-'+i"></v-img>
                                                        </a>
                                                    </template>
                                                    <template v-else-if="isLocalUrl(item.meta.title)">
                                                        <router-link :to="item.meta.title" :key="'item-'+g+'-'+i">
                                                            <v-img :src="'https://www.artlesscms.actstudio.xyz/'+item.path" aspect-ratio="1.5" width="100%" :key="'item-'+g+'-'+i"></v-img>
                                                        </router-link>
                                                    </template>
                                                    <template v-else>
                                                        <v-img :src="'https://www.artlesscms.actstudio.xyz/'+item.path" aspect-ratio="1.5" width="100%" :key="'item-'+g+'-'+i"></v-img>
                                                    </template>
                                                </template>
                                            </template>
                                        </v-col>
                                    </v-row>
                                </div>
                            </template>

                            <template v-if="gallery.field.name == 'GalleryC'">
                                <div :key="'GalleryC-'+g">
                                    <v-row align="start" class="c-px py-0">
                                        <v-col cols="4" class="c-px c-py">
                                            <template v-for="(item,i) in gallery.value">
                                                <template v-if="i == 0">
                                                    <template v-if="isUrl(item.meta.title)">
                                                        <a :href="item.meta.title" :key="'item-'+g+'-'+i">
                                                            <v-img :src="'https://www.artlesscms.actstudio.xyz/'+item.path" width="100%" :height="galleryCRectangle" :key="'item-'+g+'-'+i"></v-img>
                                                        </a>
                                                    </template>
                                                    <template v-else-if="isLocalUrl(item.meta.title)">
                                                        <router-link :to="item.meta.title" :key="'item-'+g+'-'+i">
                                                            <v-img :src="'https://www.artlesscms.actstudio.xyz/'+item.path" width="100%" :height="galleryCRectangle" :key="'item-'+g+'-'+i"></v-img>
                                                        </router-link>
                                                    </template>
                                                    <template v-else>
                                                        <v-img :src="'https://www.artlesscms.actstudio.xyz/'+item.path" width="100%" :height="galleryCRectangle" :key="'item-'+g+'-'+i"></v-img>
                                                    </template>
                                                </template>
                                            </template>
                                        </v-col>
                                        <v-col cols="4" class="c-px c-py">
                                            <template v-for="(item,i) in gallery.value">
                                                <template v-if="i == 1">
                                                    <template v-if="isUrl(item.meta.title)">
                                                        <a :href="item.meta.title" :key="'item-'+g+'-'+i">
                                                            <v-img :src="'https://www.artlesscms.actstudio.xyz/'+item.path" width="100%" :height="galleryCRectangle"  :key="'item-'+g+'-'+i"></v-img>
                                                        </a>
                                                    </template>
                                                    <template v-else-if="isLocalUrl(item.meta.title)">
                                                        <router-link :to="item.meta.title" :key="'item-'+g+'-'+i">
                                                            <v-img :src="'https://www.artlesscms.actstudio.xyz/'+item.path" width="100%" :height="galleryCRectangle"  :key="'item-'+g+'-'+i"></v-img>
                                                        </router-link>
                                                    </template>
                                                    <template v-else>
                                                        <v-img :src="'https://www.artlesscms.actstudio.xyz/'+item.path" width="100%" :height="galleryCRectangle"  :key="'item-'+g+'-'+i"></v-img>
                                                    </template>
                                                </template>
                                            </template>
                                        </v-col>
                                        <v-col cols="4" class="c-px c-py">
                                            <template v-for="(item,i) in gallery.value">
                                                <template v-if="i == 2">
                                                    <template v-if="isUrl(item.meta.title)">
                                                        <a :href="item.meta.title" :key="'item-'+g+'-'+i">
                                                            <v-img :src="'https://www.artlesscms.actstudio.xyz/'+item.path" width="100%" :height="galleryCRectangle"  :key="'item-'+g+'-'+i"></v-img>
                                                        </a>
                                                    </template>
                                                    <template v-else-if="isLocalUrl(item.meta.title)">
                                                        <router-link :to="item.meta.title" :key="'item-'+g+'-'+i">
                                                            <v-img :src="'https://www.artlesscms.actstudio.xyz/'+item.path" width="100%" :height="galleryCRectangle"  :key="'item-'+g+'-'+i"></v-img>
                                                        </router-link>
                                                    </template>
                                                    <template v-else>
                                                        <v-img :src="'https://www.artlesscms.actstudio.xyz/'+item.path" width="100%" :height="galleryCRectangle"  :key="'item-'+g+'-'+i"></v-img>
                                                    </template>
                                                </template>
                                            </template>
                                        </v-col>
                                        <v-col cols="6" class="c-px c-py">
                                            <template v-for="(item,i) in gallery.value">
                                                <template v-if="i == 3">
                                                    <template v-if="isUrl(item.meta.title)">
                                                        <a :href="item.meta.title" :key="'item-'+g+'-'+i">
                                                            <v-img :src="'https://www.artlesscms.actstudio.xyz/'+item.path" width="100%" aspect-ratio=".7959" :height-n="galleryCRectangleV" :key="'item-'+g+'-'+i"></v-img>
                                                        </a>
                                                    </template>
                                                    <template v-else-if="isLocalUrl(item.meta.title)">
                                                        <router-link :to="item.meta.title" :key="'item-'+g+'-'+i">
                                                            <v-img :src="'https://www.artlesscms.actstudio.xyz/'+item.path" width="100%" aspect-ratio=".7959" :height-n="galleryCRectangleV" :key="'item-'+g+'-'+i"></v-img>
                                                        </router-link>
                                                    </template>
                                                    <template v-else>
                                                        <v-img :src="'https://www.artlesscms.actstudio.xyz/'+item.path" width="100%" aspect-ratio=".7959" :height-n="galleryCRectangleV" :key="'item-'+g+'-'+i"></v-img>
                                                    </template>
                                                </template>
                                            </template>
                                        </v-col>
                                        <v-col cols="6" class="py-0 c-px">
                                            <v-row>
                                                <v-col cols="12" class="c-py c-px">
                                                    <template v-for="(item,i) in gallery.value">
                                                        <template v-if="i == 4">
                                                            <template v-if="isUrl(item.meta.title)">
                                                                <a :href="item.meta.title" :key="'item-'+g+'-'+i">
                                                                    <v-img :src="'https://www.artlesscms.actstudio.xyz/'+item.path" width="100%" aspect-ratio="1.7" :height-n="galleryCRectangleH" :key="'item-'+g+'-'+i"></v-img>
                                                                </a>
                                                            </template>
                                                            <template v-else-if="isLocalUrl(item.meta.title)">
                                                                <router-link :to="item.meta.title" :key="'item-'+g+'-'+i">
                                                                    <v-img :src="'https://www.artlesscms.actstudio.xyz/'+item.path" width="100%" aspect-ratio="1.7" :height-n="galleryCRectangleH" :key="'item-'+g+'-'+i"></v-img>
                                                                </router-link>
                                                            </template>
                                                            <template v-else>
                                                                <v-img :src="'https://www.artlesscms.actstudio.xyz/'+item.path" width="100%" aspect-ratio="1.7" :height-n="galleryCRectangleH" :key="'item-'+g+'-'+i"></v-img>
                                                            </template>
                                                        </template>
                                                    </template>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12" class="c-py c-px">
                                                    <template v-for="(item,i) in gallery.value">
                                                        <template v-if="i == 5">
                                                            <template v-if="isUrl(item.meta.title)">
                                                                <a :href="item.meta.title" :key="'item-'+g+'-'+i">
                                                                    <v-img :src="'https://www.artlesscms.actstudio.xyz/'+item.path" width="100%" aspect-ratio="1.7" :height-n="galleryCRectangleH" :key="'item-'+g+'-'+i"></v-img>
                                                                </a>
                                                            </template>
                                                            <template v-else-if="isLocalUrl(item.meta.title)">
                                                                <router-link :to="item.meta.title" :key="'item-'+g+'-'+i">
                                                                    <v-img :src="'https://www.artlesscms.actstudio.xyz/'+item.path" width="100%" aspect-ratio="1.7" :height-n="galleryCRectangleH" :key="'item-'+g+'-'+i"></v-img>
                                                                </router-link>
                                                            </template>
                                                            <template v-else>
                                                                <v-img :src="'https://www.artlesscms.actstudio.xyz/'+item.path" width="100%" aspect-ratio="1.7" :height-n="galleryCRectangleH" :key="'item-'+g+'-'+i"></v-img>
                                                            </template>
                                                        </template>
                                                    </template>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                </div>
                            </template>

                            <template v-if="gallery.field.name == 'GalleryD'">
                                <div :key="'GalleryD-'+g">
                                    <v-row align="start" class="c-px py-0">
                                        <v-col cols="6" class="c-px c-py">
                                            <template v-for="(item,i) in gallery.value">
                                                <template v-if="i == 0">
                                                    <v-img :src="'https://www.artlesscms.actstudio.xyz/'+item.path" width="100%" :key="'item-'+g+'-'+i" position="center bottom" aspect-ratio="1.3"></v-img>
                                                </template>
                                            </template>
                                        </v-col>
                                        <v-col cols="6" class="c-px c-py">
                                            <template v-for="(item,i) in gallery.value">
                                                <template v-if="i == 1">
                                                    <v-img :src="'https://www.artlesscms.actstudio.xyz/'+item.path" width="100%"  :key="'item-'+g+'-'+i" position="center bottom" aspect-ratio="1.3"></v-img>
                                                </template>
                                            </template>
                                        </v-col>
                                        <v-col cols="4" class="c-px c-py">
                                            <template v-for="(item,i) in gallery.value">
                                                <template v-if="i == 2">
                                                    <v-img :src="'https://www.artlesscms.actstudio.xyz/'+item.path" aspect-ratio="1.1" width="100%" :key="'item-'+g+'-'+i" position="center bottom"></v-img>
                                                </template>
                                            </template>
                                        </v-col>
                                        <v-col cols="4" class="c-px c-py">
                                            <template v-for="(item,i) in gallery.value">
                                                <template v-if="i == 3">
                                                    <v-img :src="'https://www.artlesscms.actstudio.xyz/'+item.path" aspect-ratio="1.1" width="100%" :key="'item-'+g+'-'+i"></v-img>
                                                </template>
                                            </template>
                                        </v-col>
                                        <v-col cols="4" class="c-px c-py">
                                            <template v-for="(item,i) in gallery.value">
                                                <template v-if="i == 4">
                                                    <v-img :src="'https://www.artlesscms.actstudio.xyz/'+item.path" aspect-ratio="1.1" width="100%" :key="'item-'+g+'-'+i"></v-img>
                                                </template>
                                            </template>    
                                        </v-col>
                                        <v-col cols="12" class="c-px c-py">
                                            <template v-for="(item,i) in gallery.value">
                                                <template v-if="i == 5">
                                                    <v-img :src="'https://www.artlesscms.actstudio.xyz/'+item.path" width="100%" :height="galleryDRectangle"  :key="'item-'+g+'-'+i"></v-img>
                                                </template>
                                            </template>
                                        </v-col>
                                    </v-row>
                                </div>
                            </template>

                            <template v-if="gallery.field.name == 'GalleryE'">
                                <div :key="'GalleryE-'+g">
                                    <v-row align="start" class="c-px py-0">
                                        <v-col cols="8" class="c-px c-py">
                                            <template v-for="(item,i) in gallery.value">
                                                <template v-if="i == 0">
                                                    <v-img :src="'https://www.artlesscms.actstudio.xyz/'+item.path" width="100%" :height="galleryERectangle" :key="'item-'+g+'-'+i"></v-img>
                                                </template>
                                            </template>
                                        </v-col>
                                        <v-col cols="4" class="c-px c-py">
                                            <template v-for="(item,i) in gallery.value">
                                                <template v-if="i == 1">
                                                    <v-img :src="'https://www.artlesscms.actstudio.xyz/'+item.path" width="100%" :height="galleryERectangle"  :key="'item-'+g+'-'+i"></v-img>
                                                </template>
                                            </template>
                                        </v-col>
                                        <v-col cols="4" class="c-px c-py">
                                            <template v-for="(item,i) in gallery.value">
                                                <template v-if="i == 2">
                                                    <v-img :src="'https://www.artlesscms.actstudio.xyz/'+item.path" width="100%" aspect-ratio="1.1" :key="'item-'+g+'-'+i"></v-img>
                                                </template>
                                            </template>
                                        </v-col>
                                        <v-col cols="4" class="c-px c-py">
                                            <template v-for="(item,i) in gallery.value">
                                                <template v-if="i == 3">
                                                    <v-img :src="'https://www.artlesscms.actstudio.xyz/'+item.path" width="100%" aspect-ratio="1.1" :key="'item-'+g+'-'+i"></v-img>
                                                </template>
                                            </template>
                                        </v-col>
                                        <v-col cols="4" class="c-px c-py">
                                            <template v-for="(item,i) in gallery.value">
                                                <template v-if="i == 4">
                                                    <v-img :src="'https://www.artlesscms.actstudio.xyz/'+item.path" width="100%" aspect-ratio="1.1" :key="'item-'+g+'-'+i"></v-img>
                                                </template>
                                            </template>    
                                        </v-col>
                                        <v-col cols="4" class="c-px c-py">
                                            <template v-for="(item,i) in gallery.value">
                                                <template v-if="i == 5">
                                                    <v-img :src="'https://www.artlesscms.actstudio.xyz/'+item.path" width="100%" :height="galleryCRectangle"  :key="'item-'+g+'-'+i"></v-img>
                                                </template>
                                            </template>
                                        </v-col>
                                        <v-col cols="8" class="c-px c-py">
                                            <template v-for="(item,i) in gallery.value">
                                                <template v-if="i == 6">
                                                    <v-img :src="'https://www.artlesscms.actstudio.xyz/'+item.path" width="100%" :height="galleryCRectangle"  :key="'item-'+g+'-'+i"></v-img>
                                                </template>
                                            </template>
                                        </v-col>
                                    </v-row>
                                </div>
                            </template>

                            <template v-if="gallery.field.name == 'BannerDark'">
                                <div :key="'BannerDark-'+g">
                                    <v-row>
                                        <v-col class="text-center px-0 py-1">
                                            <div style="background-color: #1D1A1B" class="py-12">
                                                <div class="py-12">
                                                    <v-img :src="'https://www.artlesscms.actstudio.xyz/'+gallery.value.path" max-height="200px" width="100%" :contain="true"></v-img>
                                                </div>
                                            </div>
                                        </v-col>
                                    </v-row>
                                </div>
                            </template>

                            <template v-if="gallery.field.name == 'TextBannerDark'">
                                <div :key="'BannerDark-'+g">
                                    <v-row>
                                        <v-col class="text-center px-0 c-py">
                                            <div style="background-color: #1D1A1B" class="pa-5">
                                                <div class="pa-5 banner-text white--text" v-html="gallery.value">
                                                </div>
                                            </div>
                                        </v-col>
                                    </v-row>
                                </div>
                            </template>
                        </template>

                        <v-row>
                            <v-col class="text-center px-0 pb-0 c-pt">
                                <div style="background-color: #1D1A1B">
                                    <div class="pa-6 banner-text-final white--text" v-html="mosaic.lastBanner">
                                    </div>
                                </div>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </div>    
</template>

<script>
import Vue from 'vue'
export default {
    data(){
        return {
            tiles: [],
            mosaic: {},
            flag: false
        }
    },
    computed: {
        galleryASquare: function () {
            return 100
        },
        galleryARectangle: function () {

            if(this.$vuetify.breakpoint.width < 600){
                return (this.$vuetify.breakpoint.width / 3)
            }

            if(this.$vuetify.breakpoint.width >= 600 && this.$vuetify.breakpoint.width < 960){
                return (this.$vuetify.breakpoint.width / 3)
            }

            if(this.$vuetify.breakpoint.width >= 960 && this.$vuetify.breakpoint.width < 1264){
                return (this.$vuetify.breakpoint.width / 3)
            }

            if(this.$vuetify.breakpoint.width >= 1264 && this.$vuetify.breakpoint.width < 1904){
                return 320
            }

            if(this.$vuetify.breakpoint.width >= 1904){
                return 320
            }

            return this.$vuetify.breakpoint.width / 3
        },
        galleryBRectangle: function () {

            if(this.$vuetify.breakpoint.width < 600){
                return (this.$vuetify.breakpoint.width / 3)
            }

            if(this.$vuetify.breakpoint.width >= 600 && this.$vuetify.breakpoint.width < 960){
                return (this.$vuetify.breakpoint.width / 3)
            }

            if(this.$vuetify.breakpoint.width >= 960 && this.$vuetify.breakpoint.width < 1264){
                return (this.$vuetify.breakpoint.width / 3)
            }

            if(this.$vuetify.breakpoint.width >= 1264 && this.$vuetify.breakpoint.width < 1904){
                return 320
            }

            if(this.$vuetify.breakpoint.width >= 1904){
                return 320
            }

            return this.$vuetify.breakpoint.width / 3
        },
        galleryCRectangle: function () {

            if(this.$vuetify.breakpoint.width < 600){
                return (this.$vuetify.breakpoint.width / 3)
            }

            if(this.$vuetify.breakpoint.width >= 600 && this.$vuetify.breakpoint.width < 960){
                return (this.$vuetify.breakpoint.width / 3)
            }

            if(this.$vuetify.breakpoint.width >= 960 && this.$vuetify.breakpoint.width < 1264){
                return (this.$vuetify.breakpoint.width / 3)
            }

            if(this.$vuetify.breakpoint.width >= 1264 && this.$vuetify.breakpoint.width < 1904){
                return 320
            }

            if(this.$vuetify.breakpoint.width >= 1904){
                return 320
            }

            return this.$vuetify.breakpoint.width / 3
        },
        galleryCRectangleV: function () {

            if(this.$vuetify.breakpoint.width < 600){
                return (this.$vuetify.breakpoint.width / 2.5)
            }

            if(this.$vuetify.breakpoint.width >= 600 && this.$vuetify.breakpoint.width < 960){
                return (this.$vuetify.breakpoint.width / 2.5)
            }

            if(this.$vuetify.breakpoint.width >= 960 && this.$vuetify.breakpoint.width < 1264){
                return (this.$vuetify.breakpoint.width / 3.5)
            }

            if(this.$vuetify.breakpoint.width >= 1264 && this.$vuetify.breakpoint.width < 1904){
                return (this.$vuetify.breakpoint.width / 3.5)
            }

            if(this.$vuetify.breakpoint.width >= 1904){
                return (this.$vuetify.breakpoint.width / 3.5)
            }

            return this.$vuetify.breakpoint.width / 3
        },
        galleryCRectangleH: function () {

            if(this.$vuetify.breakpoint.width < 600){
                return ((this.$vuetify.breakpoint.width / 5) - 32)
            }

            if(this.$vuetify.breakpoint.width >= 600 && this.$vuetify.breakpoint.width < 960){
                return ((this.$vuetify.breakpoint.width / 5) - 41)
            }

            if(this.$vuetify.breakpoint.width >= 960 && this.$vuetify.breakpoint.width < 1264){
                return ((this.$vuetify.breakpoint.width / 7) + 16)
            }

            if(this.$vuetify.breakpoint.width >= 1264 && this.$vuetify.breakpoint.width < 1904){
                return ((this.$vuetify.breakpoint.width / 7) + 16)
            }

            if(this.$vuetify.breakpoint.width >= 1904){
                return ((this.$vuetify.breakpoint.width / 7) + 16)
            }

            return this.$vuetify.breakpoint.width / 3
        },
        galleryDRectangle: function () {

            if(this.$vuetify.breakpoint.width < 600){
                return ((this.$vuetify.breakpoint.width) / 2.5)
            }

            if(this.$vuetify.breakpoint.width >= 600 && this.$vuetify.breakpoint.width < 960){
                return ((this.$vuetify.breakpoint.width) / 2.5)
            }

            if(this.$vuetify.breakpoint.width >= 960 && this.$vuetify.breakpoint.width < 1264){
                return ((this.$vuetify.breakpoint.width) / 2.5)
            }

            if(this.$vuetify.breakpoint.width >= 1264 && this.$vuetify.breakpoint.width < 1904){
                return ((this.$vuetify.breakpoint.width / 2) / 2.5)
            }

            if(this.$vuetify.breakpoint.width >= 1904){
                return ((this.$vuetify.breakpoint.width / 2) / 2.5)
            }

            return this.$vuetify.breakpoint.width / 3
        },
        galleryERectangle: function () {

            if(this.$vuetify.breakpoint.width < 600){
                return ((this.$vuetify.breakpoint.width) / 2.5)
            }

            if(this.$vuetify.breakpoint.width >= 600 && this.$vuetify.breakpoint.width < 960){
                return ((this.$vuetify.breakpoint.width) / 2.5)
            }

            if(this.$vuetify.breakpoint.width >= 960 && this.$vuetify.breakpoint.width < 1264){
                return ((this.$vuetify.breakpoint.width) / 2.5)
            }

            if(this.$vuetify.breakpoint.width >= 1264 && this.$vuetify.breakpoint.width < 1904){
                return ((this.$vuetify.breakpoint.width / 2) / 2.5)
            }

            if(this.$vuetify.breakpoint.width >= 1904){
                return ((this.$vuetify.breakpoint.width / 2) / 2.5)
            }

            return this.$vuetify.breakpoint.width / 3
        },
        galleryCRectangleV: function () {

            if(this.$vuetify.breakpoint.width < 600){
                return (this.$vuetify.breakpoint.width / 3)
            }

            if(this.$vuetify.breakpoint.width >= 600 && this.$vuetify.breakpoint.width < 960){
                return (this.$vuetify.breakpoint.width / 3)
            }

            if(this.$vuetify.breakpoint.width >= 960 && this.$vuetify.breakpoint.width < 1264){
                return (this.$vuetify.breakpoint.width / 3)
            }

            if(this.$vuetify.breakpoint.width >= 1264 && this.$vuetify.breakpoint.width < 1904){
                return (this.$vuetify.breakpoint.width / 3)
            }

            if(this.$vuetify.breakpoint.width >= 1904){
                return (this.$vuetify.breakpoint.width / 3)
            }

            return this.$vuetify.breakpoint.width / 3
        },
    },
    beforeMount: function(){
        fetch('https://www.artlesscms.actstudio.xyz/api/singletons/get/Mosaic')
            .then(collection => collection.json())

            .then((collection) => {
                var auxiliar = collection

                var auxArr = [];

                for (let index = 0; index < auxiliar.content.length; index++) {
                    const element = auxiliar.content[index];
                    if(!(element.field.name == 'BannerDark' || element.field.name == 'BannerLight' || element.field.name == 'TextBannerDark')){
                        auxArr.push(element)
                    }
                }

                auxArr = this.shuffle(auxArr);

                console.log(auxArr);

                let newArray = [];

                for (let index = 0; index < auxiliar.content.length; index++) {
                    const element = auxiliar.content[index];
                    if(!(element.field.name == 'BannerDark' || element.field.name == 'BannerLight' || element.field.name == 'TextBannerDark')){
                        newArray.push(auxArr.pop());
                    }else{
                        newArray.push(element)
                    }
                    
                }


                auxiliar.content = newArray;

                

                // for (let index = 0; index < auxiliar.content.length; index++) {
                //     var element = auxiliar.content[index];

                //     if(!(element.field.name == 'BannerDark' || element.field.name == 'BannerLight') ){
                //         element = this.shuffleArray(element.value)
                //     }
                    
                // }
                
                this.mosaic = auxiliar

            })
            .then(() => this.flag = true)
    },
    methods: {
        isUrl: function(str){
            let url;
  
            try {
                url = new URL(str);
            } catch (_) {
                return false;  
            }

            return url.protocol === "http:" || url.protocol === "https:";
        },
        isLocalUrl: function(str){
            return str.substring(0,1) === '/'
        },
        shuffleArray: function(array) {
            for (let i = array.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1));
                [array[i], array[j]] = [array[j], array[i]];
            }
            console.log(array)
            return array;
        },
        changePosition: function(arr,ind){
            for (let index = ind; index < arr.length; index++) {
                const element = arr[index];
                
            }
        },
        shuffle: function(array) {
            let currentIndex = array.length,  randomIndex;

            // While there remain elements to shuffle...
            while (currentIndex != 0) {

                // Pick a remaining element...
                randomIndex = Math.floor(Math.random() * currentIndex);
                currentIndex--;

                // And swap it with the current element.
                [array[currentIndex], array[randomIndex]] = [
                array[randomIndex], array[currentIndex]];
            }

            return array;
        }
    }
}
</script>